import axios from 'axios'
import { interceptor } from '@/application/utils/interceptor.js'

const domain = process.env.VUE_APP_API_PATH
const phoneVerificationEndpoint = `${domain}api/v1/dashboard/verify-phone/`

export const markAsVerified = () => interceptor(axios).post(phoneVerificationEndpoint)
